import React from "react";
import "./CardWithShadow.css";

interface CardWithShadowProps {
  children: React.ReactNode;
  noShadowSm?: boolean;
}

const CardWithShadow = React.forwardRef<HTMLDivElement, CardWithShadowProps>(
  ({ children, noShadowSm }, ref) => {
    return (
      <div ref={ref} className={noShadowSm ? "card no-shadow-sm" : "card"}>
        {children}
      </div>
    );
  }
);

CardWithShadow.displayName = "CardWithShadow";

export default CardWithShadow;
